import {BridgeComponent} from "@hotwired/hotwire-native-bridge";

export default class extends BridgeComponent {
    static component = "unauthentication"

    connect() {
        super.connect();

        this.send("connect");
    }
}